const middleware = {}

middleware['confirm-hard-reload'] = require('../middleware/confirm-hard-reload.js')
middleware['confirm-hard-reload'] = middleware['confirm-hard-reload'].default || middleware['confirm-hard-reload']

middleware['maintenance'] = require('../middleware/maintenance.js')
middleware['maintenance'] = middleware['maintenance'].default || middleware['maintenance']

middleware['my-events-guard'] = require('../middleware/my-events-guard.js')
middleware['my-events-guard'] = middleware['my-events-guard'].default || middleware['my-events-guard']

middleware['organizer-guard'] = require('../middleware/organizer-guard.js')
middleware['organizer-guard'] = middleware['organizer-guard'].default || middleware['organizer-guard']

middleware['users-guard'] = require('../middleware/users-guard.js')
middleware['users-guard'] = middleware['users-guard'].default || middleware['users-guard']

export default middleware
